import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  messageContentRequest,
  messageContentSuccess,
  messageContentFailure,
} from '../reducers/messageContent';
import { messageDeleteRequest } from '../reducers/messageDelete';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/message/`;

function* messageContentAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const messageId =
    state.messageContentReducer.selectedMessageId || state.teamMembersFull.selectedMessageId;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${messageId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerMessageContentSaga() {
  try {
    const response = yield call(messageContentAxios);

    const responseFromMessageContent = response.data;
    yield put(messageContentSuccess(responseFromMessageContent));
  } catch (error) {
    yield put(messageContentFailure(error));
  }
}

export function* watcherMessageContentSaga() {
  yield takeLatest(messageContentRequest().type, workerMessageContentSaga);
  yield takeLatest(messageDeleteRequest().type, workerMessageContentSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_messageContent.js